type TServicesData = {
  title: string
  descr: string
  services: string[]
  icon: string
}

export const TITLE = ['Услуги', 'Services']

export const DESCRIPRION = [
  'Мы помогаем нашим клиентам решать сложные задачи и развивать бизнес',
  'We help our clients solve complex problems and develop their business'
]

export const INCLUDE = ['Наши услуги по данному направлению включают в себя:', 'Our services include:']

export const SERVICES_DATA: Array<TServicesData[]> = [
  [
    {
      title: 'Услуги корпоративного провайдера в Гонконге',
      descr: '',
      icon: 'airplane',
      services: [
        '- Создание SPV в Гонконге',
        '- Создание офшорных компаний в Гонконге',
        '- Открытие корпоративных банковских счетов',
        '- Взаимодействие с государственными органами'
      ]
    },
    {
      title: 'Налоги и право',
      descr: 'Консультируем по правовым аспектам и вопросам национального и международного налогообложения.',
      icon: 'documents',
      services: [
        '- Консультирование по налоговому законодательству Гонконга',
        '- Консультирование по международному налогообложению',
        '- Подготовка документации по трансфертному ценообразованию',
        '- Получение индивидуальных разъяснений (rulings) от Налогового департамента Гонконга'
      ]
    }
  ],
  [
    {
      title: 'Corporate Provider Services in Hong Kong',
      descr: '',
      icon: 'airplane',
      services: [
        '- Establishing corporate structures (SPVs) in Hong Kong',
        '- Establishing offshore companies in Hong Kong',
        '- Opening corporate bank accounts',
        '- Liaising with government authorities',
        '- Ongoing CSP support'
      ]
    },
    {
      title: 'Tax and Law',
      descr: 'We advise on legal issues, national tax legislation and international tax matters.',
      icon: 'documents',
      services: [
        'Advisory on Hong Kong taxation',
        'Advisory on international taxation',
        'Preparation of transfer pricing documentation',
        'Obtaining private clarification (rulings) from Inland Revenue Department'
      ]
    }
  ]
]
